<template>
  <div class="we">
    <app-header />
    <!-- pc端st -->
    <div v-show="!showbigscreenapp" class="swiper-box rppghealth rppghealthpc" @mousewheel="rollScroll" style="float: left;width: 100%;height: 100vh;">
      <el-carousel   height="100vh" trigger="click" :loop="false" direction="vertical" :autoplay="false" ref="carousel">
        <el-carousel-item key="1">
          <div style="float: left;width: 100%;position: relative;">
            <img  src="@/assets/images/rppghealth/diyimmove1.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <img class="imgmove1" src="@/assets/images/rppghealth/diyimmove11.png" alt="">
            <img class="imgmove2" src="@/assets/images/rppghealth/diyimmove12.png" alt="">
            <img class="imgmove3" src="@/assets/images/rppghealth/diyimmove13.png" alt="">
            <!-- <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;"></div> -->
          <!--<div class="movezhuan1box">
              <div class="movezhuan1"></div>
            </div> -->
            
            <div style="width: 1380px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;height: 148px;font-size: 56px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #005BC2;line-height: 74px;float: left;margin-top: 260px;">非接触远程健康监控<br>和大规模数字健康检测</div>
              <!--   980 720= 920 676px -->
              <!-- <img src="@/assets/images/ctimaging/ctjiedudiyiimg.png" class="donghua" alt="" style="width:920px;height:676px;float: right;margin-top: 148px;"> -->
              <div style="width: 100%;height: 72px;font-size: 24px;font-family: PingFangSC, PingFang SC;color: #005BC2;line-height: 36px;float: left;margin-top: 40px;margin-right: 100px;">您的脸+我们的人工智能引擎<br>=您的健康数据<br></div>
              <div style="width: 200px;height: 50px;background: #FFFFFF;box-shadow: 0px 2px 4px 0px #005BC2;border-radius: 30px;font-size: 16px;font-family: PingFangSC, PingFang SC;color:#005BC2;line-height: 50px;text-align: center;float: left;margin-top: 100px;cursor: pointer;font-weight: 600;" @click="shenqing()">申请免费试用>></div>
              <!-- <div style="width: 200px;height: 50px;background: #FFFFFF;box-shadow: 0px 2px 4px 0px #005BC2;border-radius: 30px;font-size: 16px;font-family: PingFangSC, PingFang SC;color:#005BC2;line-height: 50px;text-align: center;float: left;margin-top: 100px;cursor: pointer;font-weight: 600;" @click="postEmail()">发邮件>></div> -->
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="2">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/rppghealth/diyim1.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;float: left;margin-left: 0;margin-top: 10%;">
                <div class="bigyinwen">VITAL SIGN MONITORING</div>
                <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 4%;">基于人脸视频的数字健康筛查系统</div>
                <!--   <div style="float: left;margin-top: 30px;width: 100%;">
                  <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
                </div> -->
                <div style="float: left;margin-top: 30px;width: 100%;">
                  <div style="width: 1000px;height: 70px;font-size: 16px;font-family: PingFangSC, PingFang SC;color: #000000;line-height: 24px;text-align: center;margin:0 auto;">
                    吾征AI通过先进的自研非接触人脸检测技术和机器深度学习算法以及认知计算技术，完成了从人脸面部扫描中提取生理指标和心理参数的目标，已实现血压、血氧、心率、心率变异性、呼吸率等十几项生命体征的检测与分析，处于国际领先水平。我们的解决方案可根据不同行业及应用进行定制化植入，满足各场景的健康需求。
                  </div>
                </div>
              </div>
              <img src="@/assets/images/rppghealth/bgscreenimg1.png" alt="" class="donghua" style="width: 1200px;height: 500px;float: left;margin-top: 4%;margin-left: 0;">
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="3">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/rppghealth/diyim1.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;float: left;margin-left: 0;margin-top: 8%;">
                <div class="bigyinwen">ACCURATE DETECTION</div>
                <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 2%;">检测准确率90%以上</div>
                <!--   <div style="float: left;margin-top: 30px;width: 100%;">
                  <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
                </div> -->
                <div style="float: left;margin-top: 30px;width: 100%;">
                  <div style="width: 1000px;height: 70px;font-size: 16px;font-family: PingFangSC, PingFang SC;color: #000000;line-height: 24px;text-align: center;margin:0 auto;">
                    通过分析视频中人脸皮肤区域的细微颜色变化，估算出脸部毛细血管的血容量变化，从而提取到脉冲信号。并进一步用于心率、心率变异性、呼吸率、血氧、血压等人体生理信号的预测。
                    <br>
                    基本原理:
                    基于生理信号异常变化特征参数数据以及对应的健康情况的样本特征参数数据，建立人脸视频信号预测人体健康的认知参数模型，并对各个参数的采集结果进行计算分析，从而实现智能预测健康情况的结果。结果客观、准确，落地性及可持续性更强。
                    吾征自研的技术能够对重要的人体健康参数进行无创、无感和方便的监测，促进用户自主健康管理和分析。
                  </div>
                </div>
              </div>
              <img src="@/assets/images/rppghealth/bgscreenimg21.png" alt="" class="donghua" style="width: 1200px;height: 500px;float: left;margin-top: 6%;margin-left: 0;">
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="4">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/rppghealth/diyim1.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;float: left;margin-left: 0;margin-top:80px;">
                <div class="bigyinwen">VIDEO INTRODUCTION</div>
                <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 20px;">视频资料</div>
              </div>
              <video controls muted loop width="300" style="width: 1200px;float: left;margin-top: 20px;margin-left: 0;aspect-ratio: 1200/675;
                  border-radius: 20px;
                  border: 4px solid;
                  border-image: linear-gradient(138deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)) 4 4;">
                <source src="https://ftp.infobigdata.com/rppg-smtzjc.mp4" />
              </video>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="5">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/rppghealth/diyim1.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;float: left;margin-left: 0;margin-top: 10%;">
                <div class="bigyinwen">WHAT WE DO</div>
                <div  style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 4%;">我们的优势</div>
                <div class="donghuahengyidong" v-if="switchvalue==1" style="float: left;margin-top: 30px;width: 1200px;height: 560px;position: relative;">
                  <img style="position:absolute;z-index: -1;" src="@/assets/images/rppghealth/bgscimg5back.png" alt="width:1200px;height:560px">
                  <div style="padding: 2%">
                    <div class="tith2">人体医学生物特征疾病知识图谱+风险算法与模型</div>
                    <div class="moxinbox">
                      <div class="moxingli" style="margin-right: 30px;">
                        <img src="@/assets/images/rppghealth/bgscimg5moxin1.png" alt="" style="position:absolute;z-index: -1;">
                        <div class="tith1">人脸检测模型</div>
                      </div>
                      <div class="moxingli" style="margin-right: 30px;">
                        <img src="@/assets/images/rppghealth/bgscimg5moxin2.png" alt="" style="position:absolute;z-index: -1;">
                        <div class="tith1">信号提取模型</div>
                      </div>
                      <div class="moxingli">
                        <img src="@/assets/images/rppghealth/bgscimg5moxin3.png" alt="" style="position:absolute;z-index: -1;">
                        <div class="tith1">疾病风险模型</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="donghuahengyidong"  v-if="switchvalue==2" style="float: left;margin-top: 30px;width: 1200px;height: 560px;position: relative;">
                  <img style="position:absolute;z-index: -1;" src="@/assets/images/rppghealth/bgscimg5back.png" alt="width:1200px;height:560px">
                  <div style="padding: 2%">
                    <div class="tith2">全新的交互方式，带来新的健康管理体验</div>
                    <div class="moxinbox">
                      <div class="moxingli" style="margin-right: 30px;">
                        <img src="@/assets/images/rppghealth/bgscimg5moxin4.png" alt="" style="position:absolute;z-index: -1;">
                        <div class="tith1">您的脸</div>
                      </div>
                      <div class="moxingli" style="margin-right: 30px;">
                        <img src="@/assets/images/rppghealth/bgscimg5moxin5.png" alt="" style="position:absolute;z-index: -1;">
                        <div class="tith1">我们的人工智能<br>引擎</div>
                      </div>
                      <div class="moxingli">
                        <img src="@/assets/images/rppghealth/bgscimg5moxin6.png" alt="" style="position:absolute;z-index: -1;">
                        <div class="tith1">您的健康数据</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="donghuahengyidong"  v-if="switchvalue==3" style="float: left;margin-top: 30px;width: 1200px;height: 560px;position: relative;">
                  <img style="position:absolute;z-index: -1;" src="@/assets/images/rppghealth/bgscimg5back3.png" alt="width:1200px;height:560px">
                  <div style="padding-top: 4%;padding-left:4%;box-sizing: border-box;">
                    <div style="width: 100%;font-family: PingFangSC, PingFang SC;font-weight: 600;font-size: 32px;color: #1C1818;line-height: 45px;text-align: left;font-style: normal;margin-bottom: 10px;">快速准确 10秒轻松实现十多种健康参数检测</div>
                    <div style="width: 100%;font-family: PingFangSC, PingFang SC;font-weight: 600;font-size: 24px;color: #1C1818;line-height: 33px;text-align: left;font-style: normal;margin-bottom: 20px;">经证明与传统PPG设备一样精确</div>
                    <div>
                      <div style="width: 40%;font-family: PingFang-SC, PingFang-SC;font-weight: 400;font-size: 24px;color: #005BC2;line-height: 33px;text-align: left;font-style: normal;">
                        无需穿戴任何设备，无需过多操作，只需要在摄像头前站几秒，即可实现包括血压、心率、心率变异性、血氧、呼吸率、房颤、情绪(压力、焦虑、抑郁等)和人体健康状况分级等精准检测。结果客观、准确，落地性及可持续性更强
                      </div>
                    </div>
                  </div>
                </div>
                <div class="donghuahengyidong"  v-if="switchvalue==4" style="float: left;margin-top: 30px;width: 1200px;height: 560px;position: relative;">
                  <img style="position:absolute;z-index: -1;" src="@/assets/images/rppghealth/bgscimg5back4.png" alt="width:1200px;height:560px">
                  <div style="padding-top: 4%;padding-left:4%;box-sizing: border-box;">
                    <div style="width: 100%;font-family: PingFangSC, PingFang SC;font-weight: 600;font-size: 32px;color: #1C1818;line-height: 45px;text-align: left;font-style: normal;margin-bottom: 10px;">自有发明专利支撑</div>
                    <div style="width: 100%;font-family: PingFangSC, PingFang SC;font-weight: 600;font-size: 24px;color: #1C1818;line-height: 33px;text-align: left;font-style: normal;margin-bottom: 20px;">基于人脸视频信号智能预测人体健康程度的方法，赋能大健康管理。</div>
                    <div>
                      <div style="width: 66%;font-family: PingFang-SC, PingFang-SC;font-weight: 400;font-size: 24px;color: #005BC2;line-height: 33px;text-align: left;font-style: normal;">
                        <!-- <span class="diandian"></span> -->
                        吾征AI认知计算技术拥有300多项发明专利及大量软著。全球智慧健康行业十大新专利申请新进入者之一，位居全球排名第九位。
                        <br>
                        <span>基于人脸视频信号智能预测人体健康的自有专利包括:</span>
                        <br>
                        <span>• 一种基于深度学习的全自动非接触式生命体征监测方法</span>
                        <br>
                        <span>• 一种基于视频流的非接触式连续血压检测应用系统</span>
                        <br>
                        <span>• 一种基于人脸视频信号的血压认知分期与健康评估的方法和装置</span>
                        <br>
                        <span>• 一种基于人脸视频的异常呼吸率与疾病风险智能认知系统</span>
                        <br>
                        <span>• 一种基于非接触式人脸视频测定精神压力的方法</span>
                        <br>
                        <span>• 一种基于人脸视频信号的驾驶员“睡驾”状态自动判别系统</span>
                        <br>
                        <span>• 基于人脸视频信号的建筑工地人员上岗前健康风险筛查方法和系统……</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width:100%;text-align:center;position: relative;float: left;">
                  <div class="swiperheng">
                    <div class="swiperhengli" @click="switchvalue=1" :style="{background:switchvalue==1?'#126BDD':''}"></div>
                    <div class="swiperhengli" @click="switchvalue=2" :style="{background:switchvalue==2?'#126BDD':''}"></div>
                    <div class="swiperhengli" @click="switchvalue=3" :style="{background:switchvalue==3?'#126BDD':''}"></div>
                    <div class="swiperhengli" @click="switchvalue=4" :style="{background:switchvalue==4?'#126BDD':''}"></div>
                  </div>
                </div>
              </div>
              <!-- <img src="@/assets/images/rppghealth/bgscreenimg2.png" alt="" class="donghua" style="width: 1200px;height: 500px;float: left;margin-top: 4%;margin-left: 0;"> -->
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="6">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/rppghealth/diyim1.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;float: left;margin-left: 0;margin-top: 10%;">
                <div class="bigyinwen">HEALTH INDEX</div>
                <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 4%;">健康指标</div>
                <!--   <div style="float: left;margin-top: 30px;width: 100%;">
                  <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
                </div> -->
                <div style="float: left;margin-top: 30px;width: 100%;">
                  <div style="width: 1000px;height: 70px;font-size: 16px;font-family: PingFangSC, PingFang SC;color: #000000;line-height: 24px;text-align: center;margin:0 auto;">
                    无感非接触式人体生命体征监测技术，能在不接触人体的情况下，仅仅通过一个普通摄像头，通过深度摄像头分析血液流动时人脸发生的细微变化，实现十几项人体生理及心理指标的检测及分析。
                  </div>
                </div>
              </div>
              <img src="@/assets/images/rppghealth/bgscreenimg6.png" alt="" class="donghua" style="width: 1200px;height: 500px;float: left;margin-top: 2%;margin-left: 0;">
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="7">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/rppghealth/diyim1.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;float: left;margin-left: 0;margin-top: 10%;">
                <div class="bigyinwen">TECHNICAL SUPERIORIT</div>
                <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 4%;">成熟的行业解决方案</div>
                <div style="float: left;margin-top: 30px;width: 1200px;height: 560px;position: relative;">
                  <img style="position:absolute;z-index: -1;" src="@/assets/images/rppghealth/bgscimg5back.png" alt="width:1200px;height:560px">
                  <div style="padding: 2%">
                    <div class="hangyebox" style="width:100%;">
                      <div class="hangyeli">
                        <img src="@/assets/images/rppghealth/hangyeli1.png" alt="" class="hangyeliimg">
                        <div class="hangyebai">
                          <div class="hangyetht1" style="line-height: 40px;">人脸检测模型</div>
                          <div class="hangyetht2">(社区老年人慢病检测)</div>
                        </div>
                      </div>
                      <div class="hangyeli">
                        <img src="@/assets/images/rppghealth/hangyeli2.png" alt="" class="hangyeliimg">
                        <div class="hangyebai">
                          <div class="hangyetht1" style="line-height: 40px;">居家养老</div>
                          <div class="hangyetht2">(身体自测)</div>
                        </div>
                      </div>
                      <div class="hangyeli">
                        <img src="@/assets/images/rppghealth/hangyeli3.png" alt="" class="hangyeliimg">
                        <div class="hangyebai">
                          <div class="hangyetht1">工地、公交车、警务工作站,<br>国家电网、中石油一线人员等</div>
                          <div class="hangyetht2">(一线人员的健康管理)</div>
                        </div>
                      </div>
                      <div class="hangyeli">
                        <img src="@/assets/images/rppghealth/hangyeli4.png" alt="" class="hangyeliimg">
                        <div class="hangyebai">
                          <div class="hangyetht1" style="line-height: 40px;">学校</div>
                          <div class="hangyetht2">(学生心理健康)</div>
                        </div>
                      </div>
                      <div class="hangyeli">
                        <img src="@/assets/images/rppghealth/hangyeli5.png" class="hangyeliimg" alt="">
                        <div class="hangyebai">
                          <div class="hangyetht1" style="line-height: 40px;">驾驶舱</div>
                          <div class="hangyetht2">(司机动态健康检测)</div>
                        </div>
                      </div>
                      <div class="hangyeli">
                        <img src="@/assets/images/rppghealth/hangyeli6.png" alt="" class="hangyeliimg">
                        <div class="hangyebai">
                          <div class="hangyetht1" style="line-height: 40px;">大型企业</div>
                          <div class="hangyetht2">(员工健康管理)</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <img src="@/assets/images/rppghealth/bgscreenimg6.png" alt="" class="donghua" style="width: 1200px;height: 500px;float: left;margin-top: 4%;margin-left: 0;"> -->
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="8">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/rppghealth/diyim1.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;float: left;margin-left: 0;margin-top: 10%;">
                <div class="bigyinwen">DEPLOYMENT MODE</div>
                <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 2%;">部署方式</div>
                <div style="float: left;margin-top: 30px;width: 1200px;height: 640px;position: relative;">
                  <img style="position:absolute;z-index: -1;width: 100%;height: 100%" src="@/assets/images/rppghealth/bgscimg5back.png" alt="吾征">
                  <div style="padding: 2%">
                    <div class="tith2" style="font-size:24px">人体医学生物特征疾病知识图谱+风险算法与模型</div>
                    <div class="moxinbox" style="margin-top:0">
                      <div class="moxingli" style="width: 30%;margin-right: 2%;">
                        <img src="@/assets/images/rppghealth/bushuli1.png" alt="" style="position:absolute;z-index: -1;;">
                        <div class="tith1" style="line-height:normal;padding-top:56%;padding-left: 10%;box-sizing: border-box;color: #1A6FD0;">
                          <div style="font-size: 40px;">本地化部署</div>
                          <div style="font-size: 24px;margin-bottom: 10px;">(1+N+N模式)</div>
                          <div style="font-size: 20px;font-weight: 400;margin-bottom: 20px;">一各平台，N套AI算法盒子，每套盒子带多套识别计算设备的模式。</div>
                          <div style="font-size: 20px;font-weight: 400;margin-bottom: 30px;">AI算法盒子包括计算、存储、网络和安全等核心功能，可对对设备生成的数据进行实时处理。</div>
                          <div style="font-size: 20px;font-weight: 600;color: #005BC2;">适用于相对集中的场景，例如：校园、健康管理机构等。</div>
                        </div>
                      </div>
                      <div class="moxingli" style="width: 30%;margin-right: 2%;">
                        <img src="@/assets/images/rppghealth/bushuli2.png" alt="" style="position:absolute;z-index: -1;">
                        <div class="tith1" style="line-height:normal;padding-top:56%;padding-left: 10%;box-sizing: border-box;color: #1A6FD0;">
                          <div style="font-size: 40px;">云平台</div>
                          <div style="font-size: 24px;margin-bottom: 10px;">(1+N模式)</div>
                          <div style="font-size: 20px;font-weight: 400;margin-bottom: 20px;">一各平台+N套识别计算一体机的模式。</div>
                          <div style="font-size: 20px;font-weight: 400;margin-bottom: 30px;">数据需要通过WIFI的形式上传云平台，计算和处理过程在云平台实现。</div>
                          <div style="font-size: 20px;font-weight: 600;color: #005BC2;">适用于分散的场景，例如：居家养老等。</div>
                        </div>
                      </div>
                      <div class="moxingli" style="width: 30%;margin-right: 2%;">
                        <img src="@/assets/images/rppghealth/bushuli3.png" alt="" style="position:absolute;z-index: -1;">
                        <div class="tith1" style="line-height:normal;padding-top:56%;padding-left: 10%;box-sizing: border-box;color: #1A6FD0;">
                          <div style="font-size: 40px;">API / SDK</div>
                          <div style="font-size: 24px;margin-bottom: 10px;">(接口模式)</div>
                          <div style="font-size: 20px;font-weight: 400;margin-bottom: 20px;">API，我们提供应用程序接口SDK，我们提供软件开发工具包。</div>
                          <div style="font-size: 20px;font-weight: 400;margin-bottom: 30px;">AI算法盒子包括计算、存储、网络和安全等核心功能，可对对设备生成的数据进行实时处理。</div>
                          <div style="font-size: 20px;font-weight: 600;color: #005BC2;">适用于有自己的平台、智能硬件，且有一定开发能力的机构。</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <img src="@/assets/images/rppghealth/bgscreenimg2.png" alt="" class="donghua" style="width: 1200px;height: 500px;float: left;margin-top: 4%;margin-left: 0;"> -->
            </div>
          </div>
        </el-carousel-item>
        <!-- 
        <el-carousel-item key="11">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">

            <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #fff;text-align: center;overflow: hidden;margin-top: 10%;margin-bottom:30px;">了解更多</div>

            <div style="float: left;width: 100%;margin-bottom:60px;">
              <div style="width: 100px;height: 10px;background:#fff;margin: 0 auto;"></div>
            </div> 
              <div style="width: 100%;float: left;margin-top: 10%;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #fff;line-height: 52px;text-align: center;"></div>
                
                <div style="width: 100%;float: left;">
                  <div style="width: 80%;padding: 0px 10%;display: flex;">
                    <div style="margin-right: 100px;flex: 1;height: 300px;background: rgba(255,255,255,0.4);border-radius: 10px;float: left;margin-left: 20px;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;">资料下载</div>
                     
                      <div style="float: left;width: 200px;height: 60px;background: linear-gradient(318deg, #289EA5 0%, #14C89B 100%);border-radius: 10px;font-size: 14px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #FFFFFF;line-height: 60px;text-align: center;margin-left:70px ;margin-top: 74px;"> <a class="aquchu" href="https://ftp.infobigdata.com/ctImageTextProductInformation.pdf" target="_blank">点击下载资料</a> </div>
                    </div>
                  </div>


                  <div style="flex: 1;height: 300px;background:rgba(255,255,255,0.4);border-radius: 10px;float: left;margin-left: 20px;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;">获取报价</div>
                      <div style="float: left;width: 200px;height: 60px;background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);border-radius: 10px;font-size: 14px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #FFFFFF;text-align: center;margin-left:70px ;margin-top: 74px;padding: 10px 0;box-sizing: border-box;cursor: pointer;" @click="cl = true">点击获取<br>详细方案及报价</div>
                    </div>
                  </div>
                  </div>
                  <div style="width: 100%;float: left;font-size: 14px;font-family: PingFangSC, PingFang SC;color: #FFFFFF;line-height: 19px;text-align: center;margin-top: 160px;">© Copyright © 2017-2021 中润普达 - 京ICP备2021002262号-1</div>
                </div>
              </div>
              
            </div>
          </div>
        </el-carousel-item> -->
      </el-carousel>
    </div>
    <!-- pc端end -->
    <!-- 移动端start -->
    <div v-show="showbigscreenapp" class="rppghealth rppghealthapp" style="float: left;width: 100%;">
      <div style="float: left;width: 100%;position: relative;margin-bottom:20px;height: 1000px;overflow: hidden;">
        <img src="@/assets/images/rppghealth/rppghealthapp1.png" alt="" style="width: 100%;position: absolute;z-index: 1;left: 0;top:-400px;aspect-ratio:375/540">
        <div style="width:100%;height: 100%;position: relative;z-index: 1;padding-left: 4%;box-sizing: border-box;">
          <div style="width: 100%;font-size: 56px;font-family: PingFangSC, PingFang SC;font-weight: bold;color: #005BC2;float: left;margin-top: 14%;">非接触远程健康监控<br>和大规模数字健康检测</div>
          <div style="width: 100%;line-height: 36px;float: left;margin-top: 10px;font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 24px;
            color: #005BC2;
            line-height: 36px;
            text-align: left;
            font-style: normal;">您的脸+我们的人工智能引擎<br>=您的健康数据<br></div>
          <div style="width: 100%;" id="btnshenqing">
            <div class="btnshenqing" @click="shenqing()">申请免费试用</div>
          </div>
        </div>
      </div>
      <div style="float: left;width: 100%;position: relative;">
        <div style="width: 100%;height: 100%;position: relative;margin: 0 auto;z-index: 1;">
          <div style="width: 100%;float: left;margin-left: 0;">
            <div class="bigyinwen" style="margin-top:40px;">VITAL SIGN MONITORING</div>
            <div style="width: 100%;float: left;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;text-align: center;overflow: hidden;margin-top: 80px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 40px;
              color: #000000;
              font-style: normal;
              ">基于人脸视频的数字健康筛查系统</div>
            <div style="float: left;margin-top: 30px;width: 100%;">
              <div style="width: 100%;font-size: 24px;font-family: PingFangSC, PingFang SC;color: #666666;line-height: 24px;text-align: center;padding:0 20px;box-sizing: border-box;
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 400;
                      font-size: 24px;
                      color: #666666;
                      line-height: 33px;
                      text-align: center;
                      font-style: normal;">
                吾征AI通过先进的自研非接触人脸检测技术和机器深度学习算法以及认知计算技术，完成了从人脸面部扫描中提取生理指标和心理参数的目标，已实现血压、血氧、心率、心率变异性、呼吸率等十几项生命体征的检测与分析，处于国际领先水平。我们的解决方案可根据不同行业及应用进行定制化植入，满足各场景的健康需求。
              </div>
            </div>
            <div style="position:relative;width: 100%;float: left;height: 980px;overflow: hidden;">
              <img src="@/assets/images/rppghealth/rppghealthapp2.png" alt="" style="width: 100%;position: absolute;z-index: 0;left: 0;bottom: 0px;">
            </div>
          </div>
        </div>
      </div>
      <div style="float: left;width: 100%;position: relative;padding-bottom: 380px;background: #F6F8FC;">
        <img src="@/assets/images/rppghealth/rppghealthapp3.png" alt="" style="width: 100%;position: absolute;z-index: 0;left: 0;top: 100px;">
        <div style="width: 100%;height: 1080px;position: relative;margin: 0 auto;z-index: 1;">
          <div style="width: 100%;float: left;margin-left: 0;margin-top: 40px;">
            <div class="bigyinwen">ACCURATE DETECTION</div>
            <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 4%;">检测准确率90%以上</div>
            <div style="float: left;margin-top: 30px;width: 94%;
                margin-left: 3%;padding:4%;box-sizing:border-box;background: rgba(255,255,255,0.7);box-shadow: 0px 6px 14px 0px rgba(0,40,121,0.1);border-radius: 20px;border: 3px solid #FFFFFF;">
              <div style="width: 100%;font-size: 16px;font-family: PingFangSC, PingFang SC;color: #666666;line-height: 24px;text-align: center;">
                通过分析视频中人脸皮肤区域的细微颜色变化，估算出脸部毛细血管的血容量变化，从而提取到脉冲信号。并进一步用于心率、心率变异性、呼吸率、血氧、血压等人体生理信号的预测。
                <br>
                基本原理:
                基于生理信号异常变化特征参数数据以及对应的健康情况的样本特征参数数据，建立人脸视频信号预测人体健康的认知参数模型，并对各个参数的采集结果进行计算分析，从而实现智能预测健康情况的结果。结果客观、准确，落地性及可持续性更强。
                吾征自研的技术能够对重要的人体健康参数进行无创、无感和方便的监测，促进用户自主健康管理和分析。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="float: left;width: 100%;position: relative;">
        <div style="width: 100%;height: 100%;position: relative;z-index: 1;">
          <div style="width: 100%;float: left;margin-left: 0;margin-top: 8%;">
            <div class="bigyinwen">VIDEO INTRODUCTION</div>
            <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 4%;">视频资料</div>
          </div>
          <div style="width: 100%;padding: 20px;box-sizing: border-box;">
            <video controls muted loop style="width: 100%;float: left;margin-top: 4%;margin-left: 0;border-radius: 20px;">
              <source src="https://ftp.infobigdata.com/rppg-smtzjc.mp4" />
            </video>
          </div>
        </div>
      </div>
      <div style="float: left;width: 100%;position: relative;box-sizing: border-box;margin-bottom: 100px;">
        <div style="width: 100%;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
          <div style="width: 100%;float: left;margin-left: 0;margin-top: 10%;padding:0 20px;box-sizing:border-box;">
            <div class="bigyinwen">WHAT WE DO</div>
            <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 4%;margin-bottom: 24px;">我们的优势</div>
            <div  style="float: left;margin-top: 30px;width: 100%;position: relative;padding: 10px 0;margin-bottom: 40px;">
              <img style="position:absolute;z-index: -1;width: 100%;left: 0px;height: 100%;border-radius: 10px;" src="@/assets/images/rppghealth/bgscimg5back.png" alt="">
              <div>
                <div class="tith2" style="font-size: 24px;">人体医学生物特征疾病知识图谱+风险算法与模型</div>
                <div class="moxinbox" style="width:100%;padding: 2%;box-sizing: border-box;">
                  <div class="moxingli moxingliback">
                    <img class="yssfliimg" src="@/assets/images/rppghealth/bgscimg5moxin1.png" alt="">
                    <div class="tith1">人脸<br>检测模型</div>
                  </div>
                  <div class="moxingli moxingliback">
                    <img class="yssfliimg" src="@/assets/images/rppghealth/bgscimg5moxin2.png" alt="">
                    <div class="tith1">信号<br>提取模型</div>
                  </div>
                  <div class="moxingli moxingliback">
                    <img class="yssfliimg" src="@/assets/images/rppghealth/bgscimg5moxin3.png" alt="">
                    <div class="tith1">疾病<br>风险模型</div>
                  </div>
                </div>
              </div>
            </div>
            <div style="float: left;margin-top: 30px;width: 100%;position: relative;padding: 10px 0px;box-sizing: border-box;">
              <img style="position:absolute;z-index: -1;width: 100%;left: 0px;border-radius: 10px;height: 100%;" src="@/assets/images/rppghealth/bgscimg5back.png" alt=" ">
              <div>
                <div class="tith2">全新的交互方式，带来新的健康管理体验</div>
                <div class="moxinbox">
                  <div class="moxingli moxingliback">
                    <img class="yssfliimg" src="@/assets/images/rppghealth/bgscimg5moxin4.png" alt="">
                    <div class="tith1">您的脸</div>
                  </div>
                  <div class="moxingli moxingliback">
                    <img class="yssfliimg" src="@/assets/images/rppghealth/bgscimg5moxin5.png" alt="">
                    <div class="tith1">我们的<br>人工智能引擎</div>
                  </div>
                  <div class="moxingli moxingliback">
                    <img class="yssfliimg" src="@/assets/images/rppghealth/bgscimg5moxin6.png" alt="">
                    <div class="tith1">您的健康数据</div>
                  </div>
                </div>
              </div>
            </div>
            <div style="float: left;margin-top: 30px;width: 100%;height: 720px;position: relative;">
              <img style="position:absolute;z-index: -1;width:100%;" src="@/assets/images/rppghealth/rppghealthapp5.png" alt="">
              <div class="youshibeijin" style="width:52%;padding: 4%;box-sizing: border-box;background: rgba(0,0,0,0);">
                <div class="youshitit1" style="width:100%;margin-bottom: 10px; 
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 600;
                  font-size: 32px;
                  color: #005BC2;
                  line-height: 45px;
                  text-align: left;
                  font-style: normal;">快速准确<br>10秒轻松实现十多种健<br>康参数检测</div>
                <div class="youshitit2" style="width:100%;margin-bottom: 20px;">经证明与传统PPG设备一样精确</div>
                <div>
                  <div class="youshitit3" style="width:88%">
                    无需穿戴任何设备，无需过多操作，只需要在摄像头前站几秒，即可实现包括血压、心率、心率变异性、血氧、呼吸率、房颤、情绪(压力、焦虑、抑郁等)和人体健康状况分级等精准检测。结果客观、准确，落地性及可持续性更强
                  </div>
                </div>
              </div>
            </div>
            <div style="float: left;margin-top: 30px;width: 100%;height: 720px;position: relative;">
              <img style="position:absolute;z-index: -1;width:100%;" src="@/assets/images/rppghealth/rppghealthapp6.png" alt="">
              <div class="youshibeijin" style="width:69%;padding: 4%;box-sizing: border-box;background: rgba(0,0,0,0);">
                <div class="youshitit1" style="width:100%;margin-bottom: 10px; 
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 600;
                  font-size: 32px;
                  color: #005BC2;
                  line-height: 45px;
                  text-align: left;
                  font-style: normal;margin-top: 30px;">自有发明专利支撑</div>
                <div class="youshitit2" style="width:100%;margin-bottom: 20px;">基于人脸视频信号智能预测人体健康程度的方法，赋能大健康管理。</div>
                <div>
                  <div style="width: 100%;font-family: PingFang-SC, PingFang-SC;font-weight: 400;font-size: 24px;color: #005BC2;line-height: 33px;text-align: left;font-style: normal;">
                    吾征AI认知计算技术拥有300多项发明专利及大量软著。全球智慧健康行业十大新专利申请新进入者之一，位居全球排名第九位。<br>
                    基于人脸视频信号智能预测人体健康的自有专利包括:<br>
                    ·一种基于深度学习的全自动非接触式生命体征监测方法<br>
                    ·一种基于视频流的非接触式连续血压检测应用系统<br>
                    ·一种基于人脸视频信号的血压认知分期与健康评估的方法和装置<br>
                    ·一种基于人脸视频的异常呼吸率与疾病风险智能认知系统<br>
                    ·一种基于非接触式人脸视频测定精神压力的方法<br>
                    ·一种基于人脸视频信号的驾驶员“睡驾”状态自动判别系统<br>
                    ·基于人脸视频信号的建筑工地人员上岗前健康风险筛查方法和系统……<br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="float: left;width: 100%;position: relative;background: #FAFBFE;">
        <div style="width: 100%;height: 100%;position: relative;margin: 0 auto;z-index: 1;">
          <div style="width: 100%;float: left;margin-left: 0;margin-top: 40px;margin-bottom: 10px;">
            <div class="bigyinwen">HEALTH INDEX</div>
            <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 4%;">健康指标</div>
            <div style="float: left;margin-top: 40px;width: 100%;">
              <div  style="width: 100%;padding: 0 20px;box-sizing: border-box;font-size: 20px;font-family: PingFangSC, PingFang SC;color: #666666;line-height: 24px;text-align: center;margin:0 auto;">
                无感非接触式人体生命体征监测技术，能在不接触人体的情况下，仅仅通过一个普通摄像头，通过深度摄像头分析血液流动时人脸发生的细微变化，实现十几项人体生理及心理指标的检测及分析。
              </div>
            </div>
          </div>
        </div>
        <div style="position:relative;float: left;width: 100%;overflow: hidden;height: 1080px;">
          <img src="@/assets/images/rppghealth/rppghealthapp7.png" alt="" style="width: 100%;position: relative;top:-340px;">
        </div>
      </div>
      <!-- 成熟的行业 -->
      <div style="float: left;width: 100%;position: relative;">
        <img src="@/assets/images/rppghealth/diyim1.png" alt="" style="width:100%;height: 100%;position: absolute;z-index: 0;left: 0;top: 0;">
        <div style="width: 100%;height: 100%;position: relative;margin: 0 auto;z-index: 1;">
          <div style="width: 100%;float: left;margin-left: 0;margin-top: 40px">
            <div class="bigyinwen">TECHNICAL SUPERIORIT</div>
            <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 40px;">成熟的行业解决方案</div>
            <div style="float: left;margin-top: 30px;width: 100%;position: relative;padding: 0 20px;box-sizing: border-box;">
              <img style="position:absolute;z-index: -1;width:calc(100% - 40px);height: 100%;" src="@/assets/images/rppghealth/bgscimg5back.png" alt="">
              <div style="padding: 2%">
                <div class="hangyebox" style="width:100%;">
                  <div class="hangyeli">
                    <img src="@/assets/images/rppghealth/hangyeli1.png" alt="" class="hangyeliimg">
                    <div class="hangyebai">
                      <div class="hangyetht1" style="line-height: 40px;">人脸检测模型</div>
                      <div class="hangyetht2">(社区老年人慢病检测)</div>
                    </div>
                  </div>
                  <div class="hangyeli">
                    <img src="@/assets/images/rppghealth/hangyeli2.png" alt="" class="hangyeliimg">
                    <div class="hangyebai">
                      <div class="hangyetht1" style="line-height: 40px;">居家养老</div>
                      <div class="hangyetht2">(身体自测)</div>
                    </div>
                  </div>
                  <div class="hangyeli">
                    <img src="@/assets/images/rppghealth/hangyeli3.png" alt="" class="hangyeliimg">
                    <div class="hangyebai">
                      <div class="hangyetht1" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;width: 100%;padding: 0 20px;margin-top: 10px;">工地、公交车、警务工作站,国家电网、中石油一线人员等</div>
                      <div class="hangyetht2">(一线人员的健康管理)</div>
                    </div>
                  </div>
                  <div class="hangyeli">
                    <img src="@/assets/images/rppghealth/hangyeli4.png" alt="" class="hangyeliimg">
                    <div class="hangyebai">
                      <div class="hangyetht1" style="line-height: 40px;">学校</div>
                      <div class="hangyetht2">(学生心理健康)</div>
                    </div>
                  </div>
                  <div class="hangyeli">
                    <img src="@/assets/images/rppghealth/hangyeli5.png" class="hangyeliimg" alt="">
                    <div class="hangyebai">
                      <div class="hangyetht1" style="line-height: 40px;">驾驶舱</div>
                      <div class="hangyetht2">(司机动态健康检测)</div>
                    </div>
                  </div>
                  <div class="hangyeli">
                    <img src="@/assets/images/rppghealth/hangyeli6.png" alt="" class="hangyeliimg">
                    <div class="hangyebai">
                      <div class="hangyetht1" style="line-height: 40px;">大型企业</div>
                      <div class="hangyetht2">(员工健康管理)</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="float: left;width: 100%;position: relative;">
        <div style="width: 100%;height: 100%;position: relative;margin: 0 auto;z-index: 1;padding-bottom: 50px;box-sizing: border-box;overflow: hidden;">
          <div style="width: 100%;float: left;margin-left: 0;margin-top:40px;">
            <div class="bigyinwen">DEPLOYMENT MODE</div>
            <div style="width: 100%;float: left;font-size: 40px;font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 40px">部署方式</div>
            <div style="float: left;margin-top: 30px;width: 100%;position: relative;">
              <!-- <img style="position:absolute;z-index: -1;width: 100%;height: 100%" src="@/assets/images/rppghealth/bgscimg5back.png" alt="吾征"> -->
              <div style="padding: 2%;overflow: hidden;">
                <div class="moxinbox" style="margin-top:0">
                  <div class="moxingli" style="width: 100%;margin-bottom: 20px;overflow: hidden;height: 400px;">
                    <img src="@/assets/images/rppghealth/rppghealthappbs1.png" alt="" style="width: 100%;position:absolute;z-index: -1;;">
                    <div class="tith1" style="line-height:normal;padding-top:4%;padding-left: 20px;box-sizing: border-box;color: #1A6FD0;font-weight: 600;width: 66%;">
                      <div style="margin-bottom:10px">
                        <span style="font-size: 40px;">本地化部署</span>
                        <span style="font-size: 24px;margin-bottom: 10px;">(1+N+N模式)</span>
                      </div>
                      <div style="height:200px;margin-bottom: 30px;">
                        <div style="font-size: 20px;font-weight: 400;margin-bottom:10px">一各平台，N套AI算法盒子，每套盒子带多套识别计算设备的模式。</div>
                        <div style="font-size: 20px;font-weight: 400;margin-bottom:10px">AI算法盒子包括计算、存储、网络和安全等核心功能，可对对设备生成的数据进行实时处理。</div>
                      </div>
                      <div style="font-size: 20px;font-weight: 600;color: #005BC2;">适用于相对集中的场景，例如：校园、健康管理机构等。</div>
                    </div>
                  </div>
                  <div class="moxingli" style="width: 100%;margin-bottom: 20px;overflow: hidden;height: 400px;">
                    <img src="@/assets/images/rppghealth/rppghealthappbs2.png" alt="" style="width: 100%;position:absolute;z-index: -1;;">
                    <div class="tith1" style="line-height:normal;padding-top:4%;padding-left: 20px;box-sizing: border-box;color: #1A6FD0;font-weight: 600;width: 66%;">
                      <div style="margin-bottom:10px">
                        <span style="font-size: 40px;">云平台</span>
                        <span style="font-size: 24px;margin-bottom: 10px;">(1+N模式)</span>
                      </div>
                      <div style="height:200px;margin-bottom: 30px;">
                        <div style="font-size: 20px;font-weight: 400;margin-bottom:10px">一各平台+N套识别计算一体机的模式。</div>
                        <div style="font-size: 20px;font-weight: 400;margin-bottom:10px">数据需要通过WIFI的形式上传云平台，计算和处理过程在云平台实现。</div>
                      </div>
                      <div style="font-size: 20px;font-weight: 600;color: #005BC2;">适用于分散的场景，例如：居家养老等。</div>
                    </div>
                  </div>
                  <div class="moxingli" style="width: 100%;margin-bottom: 20px;overflow: hidden;height: 400px;">
                    <img src="@/assets/images/rppghealth/rppghealthappbs3.png" alt="" style="width: 100%;position:absolute;z-index: -1;;">
                    <div class="tith1" style="line-height:normal;padding-top:4%;padding-left: 20px;box-sizing: border-box;color: #1A6FD0;font-weight: 600;width: 66%;">
                      <div style="margin-bottom:10px">
                        <span style="font-size: 40px;">API / SDK</span>
                        <span style="font-size: 24px;margin-bottom: 10px;">(接口模式)</span>
                      </div>
                      <div style="height:200px;margin-bottom: 30px;">
                        <div style="font-size: 20px;font-weight: 400;margin-bottom:10px">API，我们提供应用程序接口SDK，我们提供软件开发工具包。</div>
                        <div style="font-size: 20px;font-weight: 400;margin-bottom:10px">AI算法盒子包括计算、存储、网络和安全等核心功能，可对对设备生成的数据进行实时处理。</div>
                      </div>
                      <div style="font-size: 20px;font-weight: 600;color: #005BC2;">适用于有自己的平台、智能硬件，且有一定开发能力的机构。</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="fixbtnapp" id="fixbtnapp" v-show="showbigscreenapp">
      <div class="dingfixbtnapp" @click="shenqing()">申请免费试用>></div>
    </div>
    <!-- 移动端end -->
    <!-- <app-footer /> -->
    <!--  <el-dialog :modal-append-to-body="false" :custom-class="showbigscreenapp?'dialogemail dialogemailapp':'dialogemail'" title=" " :visible.sync="shenqingDialogVisible" center :close-on-click-modal="false" :close-on-press-escape="false">
      <img src="@/assets/images/rppghealth/dialogback.png" v-if="!showbigscreenapp" alt="" style="width:100%;height:100%;position: absolute;z-index: -1;">
      <div class="baobox">
        <div class="tith1" style="margin-bottom:25px">
          留下您的联系方式<br>
          我们会有专人联系您
        </div>
        <div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
            <el-form-item label="" class="elformli" prop="name">
              <div class="imgform">
                <img src="@/assets/images/rppghealth/rppgname.png" alt="">
              </div>
              <div class="titform" style="width:60px">姓名</div>
              <div class="titinput" style="width: calc(100% - 110px);">
                <el-input v-model="ruleForm.name" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item label="" class="elformli" prop="phone">
              <div class="imgform">
                <img src="@/assets/images/rppghealth/rppgphone.png" alt="">
              </div>
              <div class="titform" style="width:60px">电话</div>
              <div class="titinput" style="width: calc(100% - 110px);">
                <el-input v-model="ruleForm.phone" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item label="" class="elformli" prop="companyName">
              <div class="imgform">
                <img src="@/assets/images/rppghealth/rppgqyname.png" alt="">
              </div>
              <div class="titform" style="width:90px">企业名称</div>
              <div class="titinput" style="width: calc(100% - 140px);">
                <el-input v-model="ruleForm.companyName" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item label="" class="elformli" prop="companyType">
              <div class="imgform">
                <img src="@/assets/images/rppghealth/rppgtype.png" alt="">
              </div>
              <div class="titform" style="width:90px">企业类型</div>
              <div class="titinput" style="width: calc(100% - 140px);">
                <el-select v-model="ruleForm.companyType" placeholder="请选择" clearable>
                  <el-option label="医疗" value="医疗"></el-option>
                  <el-option label="健康" value="健康"></el-option>
                  <el-option label="教育" value="教育"></el-option>
                  <el-option label="康养" value="康养"></el-option>
                  <el-option label="车企" value="车企"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="btndengji" @click="submitForm('ruleForm')">登记</div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog> -->
    <div class="zhedialog" v-if="shenqingDialogVisible" @click.self="shenqingDialogVisible = false">
      <div :class="showbigscreenapp?'dialogemail dialogemailapp':'dialogemail'">
        <img src="@/assets/images/rppghealth/dialogback.png" v-if="!showbigscreenapp" alt="" style="width:100%;height:100%;position: absolute;z-index: -1;">
        <div class="baobox">
          <div class="tith1" style="margin-bottom:25px">
            留下您的联系方式<br>
            我们会有专人联系您
          </div>
          <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
              <el-form-item label="" class="elformli" prop="name">
                <div class="imgform">
                  <img src="@/assets/images/rppghealth/rppgname.png" alt="" class="img">
                </div>
                <div class="titform" style="width:60px">姓名</div>
                <div class="titinput" style="width: calc(100% - 110px);">
                  <el-input v-model="ruleForm.name" clearable></el-input>
                </div>
              </el-form-item>
              <el-form-item label="" class="elformli" prop="phone">
                <div class="imgform">
                  <img src="@/assets/images/rppghealth/rppgphone.png" alt="" class="img">
                </div>
                <div class="titform" style="width:60px">电话</div>
                <div class="titinput" style="width: calc(100% - 110px);">
                  <el-input v-model="ruleForm.phone" clearable></el-input>
                </div>
              </el-form-item>
              <el-form-item label="" class="elformli" prop="companyName">
                <div class="imgform">
                  <img src="@/assets/images/rppghealth/rppgqyname.png" alt="" class="img">
                </div>
                <div class="titform" style="width:120px">企业名称</div>
                <div class="titinput" style="width: calc(100% - 170px);">
                  <el-input v-model="ruleForm.companyName" clearable></el-input>
                </div>
              </el-form-item>
              <el-form-item label="" class="elformli" prop="companyType">
                <div class="imgform">
                  <img src="@/assets/images/rppghealth/rppgtype.png" alt="" class="img">
                </div>
                <div class="titform" style="width:120px">企业类型</div>
                <div class="titinput" style="width: calc(100% - 170px);">
                  <el-select v-model="ruleForm.companyType" placeholder="请选择" clearable>
                    <el-option label="医疗" value="医疗"></el-option>
                    <el-option label="健康" value="健康"></el-option>
                    <el-option label="教育" value="教育"></el-option>
                    <el-option label="康养" value="康养"></el-option>
                    <el-option label="车企" value="车企"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div style="display: flex;justify-content: space-between;width: 100%;">
                  <div v-show="showbigscreenapp" class="btndengji" style="margin-right: 2%;" @click="shenqingDialogVisible = false">取消</div>
                  <div class="btndengji"   @click.stop="submitForm('ruleForm')">登记</div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!--  <el-dialog :modal-append-to-body="false" :custom-class="showbigscreenapp?'dialogemail dialogemailapp':'dialogemail'" title=" " :visible.sync="shenqingDialogVisible" center :close-on-click-modal="false" :close-on-press-escape="false">
      <img src="@/assets/images/rppghealth/dialogback.png" v-if="!showbigscreenapp" alt="" style="width:100%;height:100%;position: absolute;z-index: -1;">
      <div class="baobox">
        <div class="tith1" style="margin-bottom:25px">
          留下您的联系方式<br>
          我们会有专人联系您
        </div>
        <div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
          
            <el-form-item label="" class="elformli" prop="name">
              <div class="imgform">
                <img src="@/assets/images/rppghealth/rppgname.png" alt="">
              </div>
              <div class="titform" style="width:60px">姓名</div>
              <div class="titinput" style="width: calc(100% - 110px);">
                <el-input v-model="ruleForm.name" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item label="" class="elformli" prop="phone">
              <div class="imgform">
                <img src="@/assets/images/rppghealth/rppgphone.png" alt="">
              </div>
              <div class="titform" style="width:60px">电话</div>
              <div class="titinput" style="width: calc(100% - 110px);">
                <el-input v-model="ruleForm.phone" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item label="" class="elformli" prop="companyName">
              <div class="imgform">
                <img src="@/assets/images/rppghealth/rppgqyname.png" alt="">
              </div>
              <div class="titform" style="width:90px">企业名称</div>
              <div class="titinput" style="width: calc(100% - 140px);">
                <el-input v-model="ruleForm.companyName" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item label="" class="elformli" prop="companyType">
              <div class="imgform">
                <img src="@/assets/images/rppghealth/rppgtype.png" alt="">
              </div>
              <div class="titform" style="width:90px">企业类型</div>
              <div class="titinput" style="width: calc(100% - 140px);">
                <el-select v-model="ruleForm.companyType" placeholder="请选择" clearable>
                  <el-option label="医疗" value="医疗"></el-option>
                  <el-option label="健康" value="健康"></el-option>
                  <el-option label="教育" value="教育"></el-option>
                  <el-option label="康养" value="康养"></el-option>
                  <el-option label="车企" value="车企"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="btndengji" @click="submitForm('ruleForm')">登记</div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import header from '@/components/header'
import footer from '@/components/footer'
import { request } from '@/network/request'
import axios from 'axios'
import { Message } from 'element-ui'
// import { Injectable } from '@nestjs/common';
// import * as nodemailer from 'nodemailer';


export default {
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('电话不能为空'));
      } else {
        if (this.ruleForm.phone !== '') {
          const reg = /^1[3456789]\d{9}$/
          if (reg.test(this.ruleForm.phone)) {
            callback();
          } else {
            this.ruleForm.phone = '';
            callback(new Error('请输入正确的手机号！'));
          }
        }
        callback();
      }
    };
    return {
      cl: false,
      zoucl: true,
      scrollBox: { time: 300 },
      liclick: 1,
      switchvalue: 1,
      shenqingDialogVisible: false, //登记弹窗.
      showbigscreenapp: false, //是否是移动端
      ruleForm: {
        name: '',
        phone: '',
        companyName: '',
        companyType: '',
      },
      rules: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '电话不能为空', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '企业名称不能为空', trigger: 'blur' },
        ],

        companyType: [
          { required: true, message: '企业类型不能为空', trigger: 'change' },
        ],

      },
      screenWidth: '',
      screenHeight: '',
    
      emailparams: {
        host: '', //服务器地址
        pass: '', //开放密码
        from: '', //发送者邮箱
        to: '', //接受者邮箱,可以设置多个
        subject: '', // 邮件主题
        text: '' // 邮件正文
      },
    }
  },
  mounted() {
    // this.getWidthHight();
    // this.showbigscreenapp=true;

    // 检测设备
    if (/(micromessenger)/i.test(navigator.userAgent)) {
        this.showbigscreenapp=true;
        console.log("微信");
      } else {
        console.log("普通浏览器");
        // 判断h5还是pc true就是h5
        let client =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          );
        if (client) {
          this.showbigscreenapp=true;
          console.log("h5");
        } else {
          console.log("pc");
           this.showbigscreenapp=false;
        }
    }
    window.addEventListener('resize', () => {
      let w = window.innerWidth;
      let h = window.innerHeight;
      if (w < 1380) {
        this.showbigscreenapp = true;
        // console.log('app');
        // _this.$nextTick(()=>{  })
      } else {
        this.showbigscreenapp = false;
        // console.log('pc');
      };
      // console.log('页面大小发生了变化,屏幕宽高', `宽度：${w}`, `高度：${h}`);
    });


    this.getEmailparams();
   

    //监听页面滚动
    window.addEventListener('scroll',function(){
      //获取页面滚动的距离(Y轴)
        var navbar = document.getElementById("fixbtnapp");
        //当距离大于100时执行动画并将导航栏设置为可见
        if(window.pageYOffset>540){
          // navbar.style.transform="translateY(0)";
          navbar.style.opacity=1;
          btnshenqing.style.opacity=1;
          // console.log('显示');
         }else{
          //收起
          navbar.style.opacity=0;
          btnshenqing.style.opacity=1;
          // navbar.style.transform="translateY(-100%)";
        }
    });

    // let passA='a89F60DEa4CDa7D7'; //密码
    // let passB='Ldhbbkingmcngumrmhtdubthgsebyxbloignuxbgtgdbnevnxbgdf'; //自定义加密参数
    // let paccZ='';
    // for(var ia in passA){
    //   paccZ=paccZ+passA[ia]+passB[ia];
    // }

    // console.log(paccZ);
    // let paccF=paccZ;
    // let paccT='';
    // for(var ia in paccF){
    //   if(ia%2 == 0){
    //     paccT=paccT+paccF[ia];
    //   }
    // }
    // console.log(paccT,'2');


  },
  created() {

  },
  methods: {


    // 申请免费试用
    shenqing() {
      this.shenqingDialogVisible = true;
      this.reset();
    },
    // 提交用户信息
    submitForm(formName) {
      console.log(11);
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        console.log(valid);
        if (valid) {
          console.log(_this.ruleForm);
          axios.post('http://tj.wuzhengai.com/rppg/website/save', _this.ruleForm)
            .then(response => {
              // 请求成功后的处理逻辑
              if (response.data.code == 200) {
                // 发邮件
                _this.postEmail();
                _this.$message({
                  message: response.data.msg,
                  type: 'success'
                });
                _this.shenqingDialogVisible = false;
              }
            })
            .catch(error => {
              // 请求失败后的处理逻辑
              console.error(error);
            });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取邮件参数
    getEmailparams() {
      console.log('获取邮件参数');
      axios.post('http://tj.wuzhengai.com/rppg/website/getOfficialWebsiteEmail')
      // axios.post('http://cmswz.infobigdata.com/rppg/website/getOfficialWebsiteEmail')
        .then(res => {
          // 请求成功后的处理逻辑
          if (res.data.code == 200) {
            // 发邮件
            this.emailparams = res.data.data;
          }
        })
        .catch(error => {
          // 请求失败后的处理逻辑
          console.error(error);
        });
    },

    // 发邮件
    // postEmail() {
    //  let texthtml=`
    //     客户姓名：${this.ruleForm.name}<br>;
    //     客户电话：${this.ruleForm.phone}<br>;
    //     客户企业名称：${this.ruleForm.companyName}<br>;
    //     客户企业类型：${this.ruleForm.companyType}<br>;
    //     `;
    //   
    //   this.emailparams.text=texthtml;
    //   fetch('http://node.wuzhengai.com/sendmail', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json'
    //       },
    //       body: JSON.stringify(this.emailparams),
    //     })
    //     .then(response => response.text())
    //     .then(result => console.log(result))
    //     .catch(error => console.log(error));
    // },


    // 发邮件
    postEmail() {
      console.log('postEmail');
      // this.ruleForm={
      //   name: '林太白',
      //   phone: '18735797974',
      //   companyName: '企业名称',
      //   companyType: '企业类型',
      // };

      let texthtml = `
        客户姓名：${this.ruleForm.name};
        客户电话：${this.ruleForm.phone};
        客户企业名称：${this.ruleForm.companyName};
        客户企业类型：${this.ruleForm.companyType};
      `;
      //  this.emailparams={
      //       host: 'smtp.263.net', //服务器地址
      //       pass: 'a89F60DEa4CDa7D7', //开放密码
      //       from: 'zhaotianhong@infobigdata.com', //发送者邮箱
      //       to: '2455067339@qq.com', //接受者邮箱,可以设置多个
      //       subject: '测试邮件发送', // 邮件主题
      //       text: texthtml // 邮件正文
      // };
      // _this.$message({
      //        message: '恭喜你，提交成功！',
      //        type: 'success'
      // });
      console.log(texthtml, '发送');
      this.emailparams.subject = "来自吾征官网邮件";
      this.emailparams.text = texthtml;
      // fetch('http://localhost:3000/sendmail', {
      fetch('http://node.wuzhengai.com/sendmail', {
          method: 'POST',
          // mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.emailparams),
        })
        .then(response => response.text())
        .then(result => {
          this.reset();
          console.log(result);
        })
        .catch(error => console.log(error));
    },

    // 获取屏幕宽高
    getWidthHight() {




    },


    // 获取邮件信息
    getEmail() {

    },
    //检测手机号
    checkPhone() {
      let _this = this;
      if (_this.ruleForm.phone != '') {
        const reg = /^1[3456789]\d{9}$/
        if (reg.test(_this.ruleForm.phone)) {} else {
          _this.ruleForm.phone = '';
          // _this.$message({
          //   message: '请输入正确的手机号！',
          //   type: 'error'
          // });
          return callback(new Error('请输入正确的手机号'));
          // return false;
        }
      }
    },


    reset() {
      this.ruleForm = {
        name: '',
        phone: '',
        companyName: '',
        companyType: '',
      };
    },
    zouni() {
      var myVideo = document.getElementById("video");
      if (myVideo.paused) {
        myVideo.play();
        this.zoucl = false;
      } else {
        myVideo.pause();
        this.zoucl = true;

      }

    },
    rollScroll(event) {
      console.log(event)
      let _that = this;
      let scrollVal = event.wheelDelta || event.detail;
      if (_that.scrollBox.time) {
        clearTimeout(_that.scrollBox.time)
      }
      _that.scrollBox.time = setTimeout(() => {
        scrollVal > 0 ? _that.$refs.carousel.prev() : _that.$refs.carousel.next();
      }, 300);
    },
  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
}

</script>
<style>


/*动画部分*/

.donghuahengyidong{
    animation: donghuahengyidong 0.4s;
    animation-timing-function: ease;
}

@keyframes donghuahengyidong {
  0% {
    opacity: 0;
   transform: translateX(-120%);
  }
  80%{
    opacity: 1;
    transform: translateX(10%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}



.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.swiper-box .el-carousel__indicator--vertical .el-carousel__button {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #CBD6F4;
  border: none;
  box-sizing: content-box;
  border: 2px solid rgba(0, 0, 0, 0);

}


.yin1 {
  width: 280px;
  height: 500px;
  float: left;
  background: url(../assets/images/cardiobrain/yin1.png) 0 0 no-repeat;
  padding: 40px 30px;
  box-sizing: border-box;
}

.yin2 {
  width: 290px;
  height: 240px;
  float: left;
  background: url(../assets/images/cardiobrain/yin2.png) 0 0 no-repeat;
  margin-left: 20px;
  padding: 40px 30px;
  box-sizing: border-box;
}

.yin3 {
  width: 290px;
  height: 240px;
  float: left;
  background: url(../assets/images/cardiobrain/yin3.png) 0 0 no-repeat;
  margin-left: 20px;
  padding: 40px 30px;
  box-sizing: border-box;
}

.yin4 {
  width: 600px;
  height: 240px;
  float: left;
  background: url(../assets/images/cardiobrain/yin4.png) 0 0 no-repeat;
  margin-left: 20px;
  margin-top: 20px;
  padding: 40px 30px;
  box-sizing: border-box;
}

.yin5 {
  width: 280px;
  height: 500px;
  float: right;
  background: url(../assets/images/cardiobrain/yin5.png) 0 0 no-repeat;
  margin-left: 20px;
  padding: 40px 30px;
  box-sizing: border-box;
}

.rppghealth .el-carousel__indicator.el-carousel__indicator--vertical .ziti {
  color: #FFF;
}

.rppghealth .el-carousel__indicator.el-carousel__indicator--vertical.is-active .ziti {
  color: #09BF88;

}

.rppghealth .key8class {
  width: 360px;
  height: 230px;
  background: #E8F8F6;
  border-radius: 10px;
  overflow: hidden;
  float: left;
  margin-bottom: 60px;
}

.rppghealth .k9classli {
  width: 25%;
  /*height: calc(100vh - 60px);*/
  height: 100vh;
  /*margin-top: 60px;*/
  background: rgba(0, 0, 0, 0.8);
  opacity: 1;
  flex: 1;
  position: relative;
}

.rppghealth .ctk6class {
  opacity: 0.8;
}

.rppghealth .ctk6classact {
  opacity: 1;
}

.rppghealth .ctk6class .ziti {
  color: rgb(9, 191, 136);
  background: #77D1C5;
  /*background: rgb(119, 209, 197);*/
}

.rppghealth .ctk6classact .ziti {
  background: rgb(255, 255, 255);
  color: rgb(9, 191, 136);
}

.rppghealth .k9classlibot {
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  color: #FFFFFF;
  padding: 20px 10%;
  width: 80%;
  margin: auto;
}

.rppghealth .k9classli:hover {
  animation: animation1 1s;
  /*transition-duration: 1s;*/
  -webkit-animation: animation1 1s;
  /* Safari and Chrome */
  background: linear-gradient(180deg, #289EA5 0%, #14C89B 100%);
}


.rppghealth .k10classli {
  box-shadow: 0px 4px 20px 0px rgba(29, 180, 159, 0.3);
  border-radius: 20px;
  width: 350px;
  height: 460px;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 0px 45px;
  position: relative;
  flex: 1;
  color: #000;
}

.rppghealth .k10classli:hover {
  animation: animation2 2s;
  -webkit-animation: animation2 2s;
  /* Safari and Chrome */
  color: #fff;
  background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);
  transition-timing-function: ease;
}

.ctfw .ctfwbot {
  bottom: 0px;
  display: none;
}

.rppghealth .donghua:hover .ctfwbot {
  bottom: 20px;
  display: block;
  animation: myfirst 2s;
  -webkit-animation: myfirst 2s;
  /* Safari and Chrome */
}

.rppghealth .donghua {
  -webkit-transition: -webkit-transform 1s ease;
  /* For Safari 3.1 to 6.0 */
  transition: transform 1s ease;
}

.rppghealth .donghua:hover {
  -ms-transform: scale(1.1);
  /* IE 9 */
  -webkit-transform: scale(1.1);
  /* Safari */
  transform: scale(1.1);
  /* 标准语法 */
}

.rppghealth .donghua1 {
  animation: myfirst 2s;
  -webkit-animation: myfirst 2s;
  /* Safari and Chrome */
}



@keyframes animation1 {
  0% {
    opacity: 0, rgba(0, 0, 0, 0.1);
    background: linear-gradient(180deg, #289EA5 0%, #14C89B 100%)
  }

  100% {
    opacity: 1;
    background: linear-gradient(180deg, #289EA5 0%, #14C89B 100%)
  }
}

@keyframes animation2 {
  0% {
    background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);
    opacity: 0
  }

  100% {
    background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);
    color: #fff;
    opacity: 1
  }
}

@keyframes myfirst {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-webkit-keyframes myfirst

/* Safari and Chrome */
  {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.aquchu {
  text-decoration: none;
  color: #fff;
}

.aquchu:hover,
.aquchu:visited,
.aquchu:link,
.aquchu:active {
  color: #fff;
}

.swiper-box .el-carousel__indicator.is-active button {
  background-color: #0038CC;
  border: 2px solid #CBD6F4;
}




/*.rppghealth 部分*/
.rppghealth .bigyinwen {
  font-size: 50px;
  font-family: PingFangSC, PingFang SC-Bold, PingFangSC, PingFang SC;
  font-weight: bold;
  color: #E8F2FF;
  position: absolute;
  z-index: -1;
  width: 100%;
  text-align: center;
}

.rppghealth .tith2 {
  width: 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #1C1818;
  line-height: 33px;
  text-align: left;
  font-style: normal;

  box-sizing: border-box;
}

.rppghealth .moxinbox {
  margin-top: 3%;
}

.rppghealth .moxingli {
  width: 360px;
  float: left;
  position: relative;
}

.rppghealth .tith1 {
  width: 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 40px;
  color: #005BC2;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  padding-top: 4%;
  padding-left: 4%;
  box-sizing: border-box;
}

.rppghealth .swiperheng {
  width: 320px;
  height: 10px;
  background: rgba(0, 90, 205, 0.14);
  border-radius: 5px;
  margin: 0 auto;
  margin-top: 20px;
}

.rppghealth .swiperheng .swiperhengli {
  border-radius: 5px;
  height: 10px;
  width: 25%;
  float: left;
}

.rppghealth .hangyebox {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: wrap;
  justify-content: flex-start;
}

.rppghealth .hangyebox .hangyeli {
  position: relative;
  width: 32%;
  margin-right: 1%;
  margin-bottom: 1%;
  cursor: pointer;
}

.rppghealth .hangyebox .hangyeliimg {
  position: relative;
  z-index: -1;
  width: 100%;
}

.rppghealth .hangyebox .hangyebai {
  width: 80%;
  background: #fff;
  width: 340px;
  height: 80px;
  background: #FFFFFF;
  box-shadow: 0px 6px 12px 0px rgba(0, 91, 194, 0.4);
  border-radius: 10px;
  border: 2px solid #FFFFFF;
  position: absolute;
  left: 4%;
  bottom: 10%;
  visibility: hidden;
  transition: all 0.3s;
}

.rppghealth .hangyebox .hangyetht1 {
  width: 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #1861B4;
  line-height: 28px;
  text-align: center;
  font-style: normal;
}

.rppghealth .hangyebox .hangyetht2 {
  width: 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #267DE1;
  line-height: 22px;
  text-align: center;
  font-style: normal;
}

.rppghealth .hangyebox .hangyeli:hover .hangyebai {
  visibility: visible;
  transform: scale(1.0);
  animation: bianhuan 1s;
  -webkit-animation: bianhuan 1s;
  
}
@keyframes bianhuan {
  0% {
    scale: 0.1;
    opacity: 0;
    transform: translate3d(10px, 0px, 0px);
/*    transform: rotate3d(1, 1, 1, 120deg);*/
  }

  100% {
    scale:1;
    opacity: 1;
/*    transform: rotate3d(1, 1, 1, 360deg);*/
  }
}
.we .dialogemail {
  width: 1200px;
  height: 640px;
  margin-top: 0;
  z-index: 9999;
  position: relative;

  border-radius: 20px;
  position: absolute;
  border-radius: 20px;
  margin: 0 auto;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
}

.we .zhedialog {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  margin: 0;
  z-index: 999;
  /*    background: #5B88BB;*/
  background: rgba(0, 0, 0, 0.4);
}

.we .v-modal {
  background: #97B3D2 !important;
  opacity: 1;
  /* width: 100%;
  height: 100%;
  margin-top:0;
  z-index: 9999;*/
}

/*.we .no-header-dialog .el-dialog__header {
  display: none;
}*/
.we .el-dialog__header {
  background: #F5F7FC;
  border: 10px 10px 0px 0px;
}

.we .baobox {
  width: 400px;
  background: #FFFFFF;
  border-radius: 20px;
  left: 60px;
  top: 60px;
  box-shadow: 0px 10px 10px 0px #B0CDFC;
  position: relative;
  padding: 20px 40px;
  box-sizing: border-box;
}

.we .baobox .tith1 {
  width: 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #005BC2;
  line-height: 33px;
  text-align: left;
  font-style: normal;
}

.we .baobox .elformli {
  background: #EAF6FF;
  line-height: 50px;
  height: 50px;
  margin-bottom: 25px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  color: #005BC2;
  line-height: 33px;
  text-align: left;
  font-style: normal;
  box-sizing: border-box;
}

.we .baobox .imgform {
  float: left;
  padding-top: 10px;
  box-sizing: border-box;
  width: 50px;
  text-align: center;
}

.we .baobox .elformli .titform {
  float: left;
  width: 30%;
  height: 50px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 22px;
  color: #005BC2;
  line-height: 50px;
  text-align: left;
  font-style: normal;
}

.we .baobox .elformli .titinput {
  float: left;
  width: calc(70% - 40px);
  margin-top: 5px;
  height: 40px;

}

.we .el-dialog--center .el-dialog__body,
.we .el-dialog__header {
  padding: 0 !important;
}




.we .btndengji {
  width: 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 30px;
  color: #FFFFFF;
  line-height: 50px;
  letter-spacing: 2px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
  text-align: center;
  background: linear-gradient( 314deg, #2D78FB 0%, #57A7FF 100%);
  border-radius: 6px;
}


/*下拉*/
.baobox .el-select-dropdown .el-scrollbar .el-select-dropdown__wrap /deep/ .el-select-dropdown__item {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 22px;
  color: #005BC2 !important;
  text-align: left;
  font-style: normal;
}

.el-select-dropdown__item {
  font-size: 22px;
  /*   color: #005BC2;*/
}
.baobox .el-select .el-input .el-select__caret {
  color: #005BC2 !important;
  height: 40px;
}

.we .baobox .elformli .el-input__inner {
  border: 0px;
  background: rgba(0, 0, 0, 0);
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 22px;
  color: #005BC2;
  text-align: left;
  font-style: normal;
}
.we .baobox .elformli .el-input__inner::placeholder {
  color: #005BC2 !important;
  font-size: 22px;
  padding: 0;
}

.el-select-dropdown__item.selected {
  color: #005BC2 !important;
  font-weight: 600;
  font-size: 22px;
}

































/*适配app部分*/

html,
body {
  min-width: 100% !important;
}

.rppghealthapp {
  background: #fff;
  font-family: PingFangSC, PingFang SC;
}

.rppghealthapp .btnshenqing {
  background: #FFFFFF;
  box-shadow: 0px 12px 24px 0px rgba(0, 91, 194, 0.4);
  border-radius: 30px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #005BC2;
  font-style: normal;
  width: 220px;
  height: 60px;
  background: #FFFFFF;
  border-radius: 30px;
  font-family: PingFangSC, PingFang SC;
  color: #005BC2;
  line-height: 60px;
  text-align: center;
  float: left;
  margin-top: 60px;
  cursor: pointer;
  font-weight: 600;
}

.rppghealthapp .rppghealthback1 {
  /*background: url('~@/assets/images/rppghealth/diyim.png') no-repeat;*/
  background: url('~@/assets/images/rppghealth/rppghealthapp1.png') no-repeat;
  background-size: cover;
  background-position: 96% 30%;
  background-size: 1800px auto;
}

.rppghealthapp .rppghealthback2 {
  background: url('~@/assets/images/rppghealth/rppghealthapp2.png') no-repeat;
  background-position: 0% 70%;
  background-size: 87% auto;
}

.rppghealthapp .rppghealthback3 {
  background: url('~@/assets/images/rppghealth/rppghealthapp3.png') no-repeat;
  background-position: 0% 32%;
  background-size: 87% auto;
  height: 1080px;
}

.rppghealthapp .moxingliback {
  /* background: url('~@/assets/images/rppghealth/bgscimg5moxin1.png') no-repeat;*/
  background-position: 0% 0%;
  background-size: 100% auto;
  height: 460px;
  border-radius: 10px;
  border: 2px solid #FFFFFF;
  margin: 1%;
  width: 31%;
  height: 446px;
  overflow: hidden;
}

.rppghealthapp .yssfliimg {
  position: absolute;
  z-index: -1;
}

.rppghealthapp .tith2 {
  padding: 20px;
  padding-bottom: 10px;


  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #1C1818;
  line-height: 33px;
  text-align: left;
  font-style: normal;
}

/* 当页面宽度大于 1380px */
/*@media screen and (min-width:1380px) {}

/* 当页面宽度大于960px小于1380px */
/*@media screen and (min-width:960px) and (max-width:1380px) {}*/

/* 页面宽度小于1380px */
@media screen and (max-width:1380px) {
  .nav-warp {
    visibility: hidden !important;
  }

  .youshibeijin {
    padding-top: 4%;
    padding-left: 4%;
    box-sizing: border-box;
    width: 54%;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 10px;
    margin: 2%;
  }

  .youshibeijin .youshitit1 {
    width: 80%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 32px;
    color: #005BC2;
    line-height: 45px;
    text-align: left;
    font-style: normal;
  }

  .youshibeijin .youshitit2 {
    width: 100%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #1C1818;
    line-height: 33px;
    text-align: left;
    font-style: normal;
    margin-bottom: 20px;
  }

  .youshibeijin .youshitit3 {
    width: 66%;
    font-family: PingFang-SC, PingFang-SC;
    font-weight: 400;
    font-size: 24px;
    color: #005BC2;
    line-height: 33px;
    text-align: left;
    font-style: normal;
  }

  .rppghealth .hangyebox .hangyeli {
    position: relative;
    width: 49%;
    margin-right: 1%;
    margin-bottom: 1%;
    cursor: pointer;
  }

  .rppghealthapp .hangyebox .hangyebai {
    width: 92%;
    height: 70px;
    visibility: visible;
  }
}


/*app弹窗部分*/
.we .dialogemailapp {
  width: 100% !important;
  /*background: #97b3d2;
     background: rgba(0, 0, 0, 0.4);*/
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  height: 100%;
}

.we .dialogemailapp .baobox {
  width: 100%;
  width: calc(100% - 8%);
  background: #FFFFFF;
  border-radius: 20px;
  left: 4%;
  top: 14%;
  box-shadow: 0px 10px 10px 0px #B0CDFC;
  position: relative;
  box-sizing: border-box;
}

.we .dialogemailapp .tith1 {
  font-size: 40px;
  line-height: 56px;
  margin-bottom: 40px;
}

.we .dialogemailapp .baobox .elformli {
  background: #EAF6FF;
  line-height: 80px;
  height: 80px;
  border-radius: 6px;



  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 30px;
  color: #005BC2;
  font-style: normal;

}

.we .dialogemailapp .baobox .elformli .titform {

  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 30px;
  color: #005BC2;
  height: 80px;
  line-height: 80px;
  text-align: left;
  font-style: normal;
}

.we .dialogemailapp .baobox .imgform {
  float: left;
  width: 50px;
  margin: 0px;
  padding: 0px;
  height: 80px;
  line-height: 1;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.we .dialogemailapp .baobox .img {
  float: left;
  width: 38px;
}

.we .dialogemailapp .baobox .elformli .titinput {
  float: left;
  margin: 0;
  padding: 0;
  height: 80px;
  font-size: 30px;
  line-height: 80px;
}
.we .dialogemailapp .baobox .elformli /deep/ .el-input__inner::placeholder {
  font-size: 24px;
  padding: 0;
}

.we .dialogemailapp .btndengji {
  line-height: 80px;
  height: 80px;
  background: linear-gradient( 314deg, #2D78FB 0%, #57A7FF 100%);
  border-radius: 12px;
  font-size: 40px;
  color: #FFFFFF;
  letter-spacing: 3px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  margin-top: 60px;
}

.we .dialogemailapp .elformli .el-input__inner {
  border: 0px;
  background: rgba(0, 0, 0, 0);
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 30px;
  color: #005BC2;
  text-align: left;
  font-style: normal;
}
.we .dialogemailapp .elformli .el-input__inner::placeholder {
  color: #005BC2 !important;
  font-size: 30px;
  padding: 0;
}
/*.dialogemailapp /deep/ .el-select-dropdown__item{
  font-size: 42px !important;
}*/
.we .diandian{
  width: 4px;
  height: 4px;
  background: #005BC2;
}
.we .movezhuan1box{ 
  width: 160px;
    height: 160px;
    position: absolute;
    right: 40%;
    top: 25vh;
    -webkit-transform: rotate(104deg);
    transform: rotate(104deg);
}
.we .movezhuan1{ 
  width: 80%;
  height: 80%;
  opacity: 0.6;
  background: #005bc2;
  background: #fff;
  opacity: 0.3;
  border-radius: 50%;
  border: 8px solid #000;
  border-left: 8px solid #000;
  border-right: 8px solid #000;
  background: rgba(0,0,0,0);
  
 /*   -moz-animation: animovezhuan1 1.5s linear infinite;
    -o-animation: animovezhuan1 1.5s linear infinite;
    -ms-animation: animovezhuan1 1.5s linear infinite;
    -webkit-animation: animovezhuan1 1.5s linear infinite;
    animation: animovezhuan1 1.5s linear infinite;*/
}

 @keyframes animovezhuan1 {
       0% {
          -webkit-transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          -ms-transform: rotate(360deg);
          transform: rotate(360deg);
        } 
}
.imgmove1{
   width: 200px;
    position: absolute;
    z-index: 2;
    right: 38%;
    bottom: 22%;
   -moz-animation: aniimgmove1 4s linear infinite;
    -o-animation: aniimgmove1 4s linear infinite;
    -ms-animation: aniimgmove1 4s linear infinite;
    -webkit-animation: aniimgmove1 4s linear infinite;
    animation: aniimgmove1 4s linear infinite; 
}
 @keyframes aniimgmove1 {
       0% {
           bottom: 22%;
        }
        50%{
          bottom: 28%;
        }
        100% {
          bottom: 22%;
   } 
}

.imgmove2{
    width: 180px;
    position: absolute;
    z-index: 2;
    right: 32%;
    bottom: 48%;
  -moz-animation: aniimgmove2 4s linear infinite;
    -o-animation: aniimgmove2 4s linear infinite;
    -ms-animation: aniimgmove2 4s linear infinite;
    -webkit-animation: aniimgmove2 4s linear infinite;
    animation: aniimgmove2 4s linear infinite;  
}
 @keyframes aniimgmove2 {
       0% {
         bottom: 48%;
        }
        50%{
          bottom: 54%;
        }
        100% {
           bottom: 48%;
        } 
}
.imgmove3{
    width: 200px;
    position: absolute;
    z-index: 3;
    right: 4%;
    bottom:20%;
   -moz-animation: aniimgmove3 4s linear infinite;
    -o-animation: aniimgmove3 4s linear infinite;
    -ms-animation: aniimgmove3 4s linear infinite;
    -webkit-animation: aniimgmove3 4s linear infinite;
    animation: aniimgmove3 4s linear infinite;

}
 @keyframes aniimgmove3 {
       0% {
            bottom:20%;
        }
        50%{
          bottom:26%;
        }
        100% {
          bottom:20%;
   } 
}

/*app固定部分*/
.fixbtnapp{
    position: fixed;
    z-index: 999;
    right: 40px;
    top: 40px;
    opacity: 0;
}
.dingfixbtnapp{
    width: 220px;
    height: 60px;
    background: rgb(255, 255, 255);
    box-shadow: rgb(0, 91, 194) 0px 2px 4px 0px;
    border-radius: 30px;
    font-size: 16px;
    font-family: PingFangSC, "PingFang SC";
    color: rgb(0, 91, 194);
    line-height: 50px;
    text-align: center;
    float: left;
    margin-top: 100px;
    cursor: pointer;
    font-weight: 600;
    font-size: 24px;
    line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/rppghealth.vue